import { apiInstances } from '../../../../libs';

const { post } = apiInstances.orderInstance;

export default async function confirmReceivedFromWarecloud({
  id_order,
  ...payload
}) {
  const response = await post(
    `/clouders/orders/${id_order}/pickupWarecloud`,
    payload
  );

  return response;
}
